/**
 * @packageDocumentation
 * @module      SystemExDto.ts
 * @description Models the Data-Transfer Object for creating or updating a System
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
/**
 * Encapsulates the data needed to create or update a system.
 */
export default class SystemExDto {
    /**
     * Construct from a SystemEx object.
     *
     * @param systemEx
     */
    constructor(systemEx) {
        var _a;
        this.systemId = systemEx.system.systemId;
        this.systemName = systemEx.system.systemName;
        this.isControlSide = systemEx.system.isControlSide;
        this.isEnabled = systemEx.system.isEnabled;
        this.hospitalName = systemEx.system.hospitalName;
        this.address = systemEx.system.address;
        this.version = systemEx.system.version;
        this.password = ((_a = systemEx.user) === null || _a === void 0 ? void 0 : _a.password) || null;
    }
    /**
     * Convert this object to a JSON object.
     */
    toJSON() {
        const jsonObj = Object.assign({}, this);
        jsonObj.systemId = this.systemId;
        jsonObj.systemName = this.systemName;
        jsonObj.isControlSide = this.isControlSide;
        jsonObj.isEnabled = this.isEnabled;
        jsonObj.hospitalName = this.hospitalName;
        jsonObj.address = this.address;
        jsonObj.version = this.version;
        jsonObj.password = this.password;
        return jsonObj;
    }
}
//# sourceMappingURL=SystemExDto.js.map